import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';
import { Models } from '../../models/global.models';
import { BorrowerLeadStore } from './borrower-lead.store';

@Injectable({ providedIn: 'root' })
export class BorrowerLeadQuery extends Query<Models.BorrowerInformationLeadForm> {
  protected store: BorrowerLeadStore;

  dirtyCheck = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(BorrowerLeadStore);

    super(store);

    this.store = store;
  }
}
